import { providerList } from '@blax-modules/base-front-end/resources/js/utilities/providers';

import { Home } from './parts/home.js';
providerList.instantiate('Home', Home);

import { Map } from './parts/map.js';
providerList.instantiate('Map', Map);

import { Menu } from './parts/menu.js';
providerList.instantiate('Menu', Menu);

import { Header } from './parts/header.js';
providerList.instantiate('Header', Header);

import { tns } from "tiny-slider/src/tiny-slider"

const SLIDER_CONFIG = {
    container: '.slider',
    gutter: 0,
    swipeAngle: false,
    controls: false,
    mouseDrag: true,
    slideBy: 1,
    items: 1,
    autoplay: true,
    autoplayButtonOutput: false,
    navPosition: 'bottom',
    preventScrollOnTouch: 'force',
    responsive: {
        '769': {
            items: 3,
            slideBy: 3,
            preventScrollOnTouch: 'auto',
        }
    }
}

document.addEventListener('DOMContentLoaded', () => {
    let sliderEl = document.querySelector('.career-slider .slider')
    if (!sliderEl) {
        return
    }
    let slider = tns(SLIDER_CONFIG);
})
